import React from "react";
import InnerHeader from "../../component/shared/innerheader/InnerHeader.js";
import { useIntl } from "react-intl";
import { END_POINTS } from "constants/APIConstant.js";
import ReactGA from "react-ga4";

function Notfound() {
  const intl = useIntl();

  React.useEffect(() => {
    const timeOut = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
    return () => {
      clearTimeout(timeOut);
    };
  }, []);

    
  ReactGA.initialize(END_POINTS.TRACKING_ID)

  React.useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({ hitType: "pageview", page: "/*", title: "Notfound Page" });
  }, []);



  return (
    <>
      <InnerHeader
        breadcrumb={[
          {
            title: intl.formatMessage({ id: "page-notfound" }),
            clickClass: true,
          },
        ]}
        title={intl.formatMessage({ id: "page-notfound" })}
        route={"../external-trade"}
      />
      <div className="container d-flex justify-content-center align-items-center py-5">
        <div className="text-center fw-semibold">
            <h5>{intl.formatMessage({ id: "page-notfound" })}</h5>
        </div>
      </div>
    </>
  );
}

export default Notfound;
